export default "__VITE_ASSET__B7zSJ2K8__"